import { useTranslation } from "react-i18next";
import SimpleGrid from "@vfuk/core-simple-grid";
import { Stack } from "@ucchub/ui";
import Paragraph from "@vfuk/core-paragraph";
import { findName } from "./FindName";
import { CommercialCriteriaGridProps } from "./AllProps.types";
import useServiceType from "@hooks/serviceType/useServiceType";
import useUseCase from "@hooks/useCase/useUseCase";
import useNumberType from "@ucchub/ui/src/cloudNumbers/hooks/numberType/useNumberType";
import { useEffect } from "react";

const CommercialCriteriaGrid = ({
  commercialCriteria,
  countryList,
}: CommercialCriteriaGridProps) => {
  const { t } = useTranslation();

  const { fetchServiceTypeList, serviceTypeList } = useServiceType();
  const { fetchUseCaseList, useCaseList } = useUseCase();
  const { fetchNumberTypeList, numberTypeList } = useNumberType();

  useEffect(() => {
    fetchNumberTypeList({
      countryId: commercialCriteria.countryId,
    });
    fetchServiceTypeList({
      "ids[]": [commercialCriteria.serviceTypeId],
      countryId: commercialCriteria.countryId,
      numberTypeId: commercialCriteria.numberTypeId,
    });
    fetchUseCaseList({
      countryId: commercialCriteria.countryId,
      numberTypeId: commercialCriteria.numberTypeId,
      serviceTypeId: commercialCriteria.serviceTypeId,
      "ids[]": [commercialCriteria.useCaseId],
    });
  }, [commercialCriteria]);

  const tableData = [
    {
      displayText: t("core:commercialCriteria.commercial_criteria_name"),
      value: commercialCriteria.name,
    },
    {
      displayText: t("core:commercialCriteria.country"),
      value: findName(countryList, commercialCriteria.countryId),
    },
    {
      displayText: t("core:commercialCriteria:number_type"),
      value: findName(numberTypeList, commercialCriteria.numberTypeId),
    },
    {
      displayText: t("core:commercialCriteria:service_type"),
      value: findName(serviceTypeList, commercialCriteria.serviceTypeId),
    },
    {
      displayText: t("core:commercialCriteria:use_case"),
      value: findName(useCaseList, commercialCriteria.useCaseId),
    },
  ];
  return (
    <>
      <SimpleGrid spacing={4} columns={{ sm: 3 }}>
        {tableData.map((item) => (
          <Stack key={item.displayText} direction="column" align="flex-start">
            <Paragraph weight={3} noMargin>
              {item.displayText}
            </Paragraph>
            <Paragraph>{item.value}</Paragraph>
          </Stack>
        ))}
      </SimpleGrid>
    </>
  );
};
export default CommercialCriteriaGrid;
